
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/venues/[slug]",
      function () {
        return require("private-next-pages/venues/[slug].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/venues/[slug]"])
      });
    }
  